// MANISH CUSTOM CODE - LOGO GRID CYCLE - START
// Static logo grid. All slots advance TOGETHER on a single shared timer.
//
// THIS UPDATE: guarantees the same logo can never appear in two blocks
// at the same time. Each cycle, the full pool of logos is shuffled and
// the first N (= number of slots) are handed out one each — since there
// are always at least as many logos as slots (enforced server-side in
// the Liquid), this is always possible. Also makes a best effort (a few
// retries) to land an assignment where every slot's new logo differs
// from what it's currently showing, so the change is always visible.

function mmInitLogoGridCycle(grid) {
  if (grid.dataset.mmLgcInit) return;
  grid.dataset.mmLgcInit = 'true';

  const cycleSeconds = parseFloat(grid.dataset.mmLgcCycleSpeed || '4');
  const cycleMs = Math.max(1500, cycleSeconds * 1000);
  const totalLogos = parseInt(grid.dataset.mmLgcTotalLogos || '0', 10);

  const slotEls = Array.from(grid.querySelectorAll('[data-mm-lgc-slot]'));
  if (totalLogos <= 1 || slotEls.length === 0) return;

  // For each slot, map logoIndex -> its item element, and note the
  // logoIndex currently active.
  const slots = slotEls.map((slotEl) => {
    const itemsByLogoIndex = new Map();
    let currentLogoIndex = null;

    slotEl.querySelectorAll('[data-mm-lgc-item]').forEach((itemEl) => {
      const logoIndex = parseInt(itemEl.dataset.mmLgcLogoIndex, 10);
      itemsByLogoIndex.set(logoIndex, itemEl);
      if (itemEl.classList.contains('is-active')) currentLogoIndex = logoIndex;
    });

    return { itemsByLogoIndex, currentLogoIndex };
  });

  function shuffledLogoIndices() {
    const arr = Array.from({ length: totalLogos }, (_, i) => i);
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function pickAssignment() {
    // Try a handful of shuffles, keep the one where the most slots land
    // on a genuinely different logo than they're currently showing.
    let best = null;
    let bestChangedCount = -1;

    for (let attempt = 0; attempt < 8; attempt++) {
      const shuffled = shuffledLogoIndices().slice(0, slots.length);
      let changedCount = 0;
      shuffled.forEach((logoIndex, i) => {
        if (logoIndex !== slots[i].currentLogoIndex) changedCount++;
      });

      if (changedCount > bestChangedCount) {
        bestChangedCount = changedCount;
        best = shuffled;
      }
      if (changedCount === slots.length) break; // every slot would change - good enough
    }

    return best;
  }

  function advanceAll() {
    const assignment = pickAssignment();

    slots.forEach((slot, i) => {
      const newLogoIndex = assignment[i];
      if (newLogoIndex === slot.currentLogoIndex) return; // nothing to do for this slot this round

      const currentEl = slot.itemsByLogoIndex.get(slot.currentLogoIndex);
      const nextEl = slot.itemsByLogoIndex.get(newLogoIndex);
      if (!nextEl) return;

      if (currentEl) currentEl.classList.remove('is-active');
      nextEl.classList.add('is-active');
      slot.currentLogoIndex = newLogoIndex;
    });
  }

  window.setInterval(advanceAll, cycleMs);
}

function mmInitAllLogoGridCycles() {
  document.querySelectorAll('[data-mm-lgc-grid]').forEach(mmInitLogoGridCycle);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mmInitAllLogoGridCycles);
} else {
  mmInitAllLogoGridCycles();
}

// Re-init when the section is reloaded live in the theme editor.
document.addEventListener('shopify:section:load', mmInitAllLogoGridCycles);

// MANISH CUSTOM CODE - LOGO GRID CYCLE - END
